<template>
    <div>
        <h1 class="mt-3 mx-2">Verwaltung der Studiengänge</h1>

        <content-collapse
            title="Import der Studiengänge über CSV"
            :collapse-key="studiengangUploadCollapseId"
        >
            <StudiengangUpload />
        </content-collapse>

        <content-collapse title="Import-Logfile anzeigen" :collapse-key="studiengangLogCollapseId">
            <ImportlogViewer filename="csvimport_studiengaenge.log" />
        </content-collapse>

        <ContentCollapse
            title="Liste der Studiengänge und Fachbereiche"
            :collapse-key="studiengangListCollapseId"
            is-visible-by-default
        >
            <StudiengangList />
        </ContentCollapse>
    </div>
</template>

<script>
    import StudiengangList from './Studiengang/StudiengangList.vue'
    import StudiengangUpload from './Studiengang/StudiengangUpload.vue'
    import ImportlogViewer from './ImportlogViewer/ImportlogViewer.vue'
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import { useFachbereichStore, useStudiengangStore } from '@/js/stores'

    export default {
        name: 'Studiengaenge',
        components: {
            ContentCollapse,
            StudiengangList,
            StudiengangUpload,
            ImportlogViewer
        },
        props: {},
        data: function () {
            return {
                studiengangCreateCollapseId: 'collapse-studiengang-create',
                studiengangListCollapseId: 'collapse-studiengang-list',
                studiengangUploadCollapseId: 'collapse-studiengang-upload',
                studiengangLogCollapseId: 'collapse-studiengang-log',
            }
        },
        computed: {},
        watch: {},
        async mounted() {
            await Promise.all([
                this.fachbereichStore.fetchFachbereiche(),
                this.studiengangStore.fetchStudiengaenge()
            ])
        },
        methods: {},
        setup() {
            const studiengangStore = useStudiengangStore()
            const fachbereichStore = useFachbereichStore()

            return {
                studiengangStore,
                fachbereichStore
            }
        }
    }
</script>

<style scoped lang="scss"></style>
